import { Link } from "react-router-dom";
import { Download, Trophy, MapPin, Clock, Users, ChevronRight, Flag } from "lucide-react";
import SectionHeading from "../components/SectionHeading";

export default function GolfTournament() {
  return (
    <main className="pt-24">
      {/* Hero */}
      <section className="relative h-[70vh] min-h-[520px] w-full overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=1800&auto=format&fit=crop"
          alt="Golf course"
          className="absolute inset-0 w-full h-full object-cover slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A3161]/70 via-[#0A3161]/50 to-[#0A3161]" />
        <div className="relative h-full flex items-end pb-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full text-white fade-up">
            <p className="font-condensed uppercase tracking-[0.3em] text-xs text-[#FFFFFF] mb-4">
              Freedom Ain't Free
            </p>
            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95]">
              Bobby Rager Memorial
              <br />
              <span className="italic text-[#FFFFFF]">Golf Tournament</span>
            </h1>
            <p className="mt-6 text-xl md:text-2xl text-white/85 max-w-2xl">
              Country Hills Golf Course  |  Hendersonville, TN
            </p>
          </div>
        </div>
      </section>

      {/* Details */}
      <section className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="Tournament Details"
              title="A 4-Person Scramble That Fuels Our Mission"
              description="Every entry, every sponsorship, every dollar goes directly to programs that support Sumner County veterans and their families. Sponsored by Family Legacy."
            />

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {[
                { icon: Clock, label: "Registration", value: "6:45 AM" },
                { icon: Flag, label: "Shotgun Start", value: "8:00 AM" },
                { icon: Users, label: "Format", value: "4-Person Scramble" },
                { icon: Trophy, label: "Entry Fee", value: "$75 per player" },
              ].map((s, i) => (
                <div key={i} className="border border-[#D9DDE3] p-6 bg-white">
                  <s.icon className="w-6 h-6 text-[#B22234]" />
                  <p className="mt-4 font-condensed uppercase tracking-widest text-xs text-[#374151]">
                    {s.label}
                  </p>
                  <p className="mt-1 font-display text-2xl text-[#0A3161] font-bold">{s.value}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 bg-[#EEF1F6] border-l-4 border-[#B22234] p-6">
              <p className="font-condensed uppercase tracking-widest text-xs text-[#B22234]">
                Included With Entry
              </p>
              <ul className="mt-4 grid sm:grid-cols-2 gap-2 text-[#0A3161]">
                {[
                  "Green fees",
                  "Cart",
                  "Range balls",
                  "Gift bag",
                  "Lunch",
                  "Closest to the Pin contest",
                  "Target Drive contest",
                  "Camaraderie & memories",
                ].map((t, k) => (
                  <li key={k} className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-[#B22234] rounded-full" /> {t}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#register"
                className="inline-flex items-center gap-2 bg-[#B22234] hover:bg-[#8f1b2a] text-white px-8 h-12 font-condensed uppercase tracking-widest text-xs"
              >
                <Download className="w-4 h-4" /> Registration Flyer
              </a>
              <Link
                to="/activities"
                className="inline-flex items-center gap-2 border border-[#0A3161] text-[#0A3161] hover:bg-[#0A3161] hover:text-white px-8 h-12 font-condensed uppercase tracking-widest text-xs transition-colors"
              >
                All Activities <ChevronRight className="w-4 h-4" />
              </Link>
            </div>
          </div>

          <aside className="lg:col-span-5">
            <div className="sticky top-32 space-y-6">
              <div className="bg-[#0A3161] text-white p-8">
                <p className="font-condensed uppercase tracking-widest text-xs text-[#FFFFFF]">
                  Contact
                </p>
                <h3 className="mt-2 font-display text-2xl font-bold">Byron Personett</h3>
                <p className="mt-4 text-white/80">Tournament Coordinator</p>
                <div className="mt-6 pt-6 border-t border-white/10 space-y-2">
                  <a href="tel:6155941153" className="block text-white hover:text-[#FFFFFF]">
                    615-594-1153
                  </a>
                  <a href="mailto:personet@aol.com" className="block text-white hover:text-[#FFFFFF]">
                    personet@aol.com
                  </a>
                </div>
              </div>
              <div className="relative overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=800&auto=format&fit=crop"
                  alt="Golf"
                  className="w-full h-64 object-cover"
                />
              </div>
              <div className="bg-[#B22234] text-white p-8">
                <p className="font-display italic text-2xl leading-snug">
                  Come on out and play!
                </p>
                <p className="mt-3 font-condensed uppercase tracking-widest text-xs text-[#FFFFFF]">
                  All proceeds benefit Sumner County veterans
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
